export class Inspection {
     pONumber :string;
     pODate :Date;
     project :string;
     customerNo :string;
     customerName :string;
     attention :string;
     designation :string;
     mobileNo :string;
     inspectionCallDate :Date;
     proposedInspectionDate :Date;
     placeofinspection :string;
     venodrNo :string;
     venodrName :string;
     vendorsContactPerson :string;
     manufacturersNameandAddress :string;
     contactPerson :string;
     category :boolean;
     requestedBy :string;
     requestedOn :Date;
     requestInspection :Boolean;
     remarksProject :string;
     remarksBy :string;
     remarksQc :string;
     inspectionDateFrom :Date;
     inspectionDateTo :Date;
     inspectionCompleted :Boolean;
     remarks :string;
     customersMdccUploaded :Boolean;
     cocUploaded :Boolean;
     linkedToNgslMdcc :Boolean;
     isSendtoVendor :Boolean;
     MdccSentOn :Date;
     status :string;
     inspectionNo :string;
     inspectionStatus :string;
     mdccdoc :string;
     mdccdocCopySource :string;
     proposedDateofInspection :Date;
     vendorAddress :string;
     customerOrderNo :string;
     customerOrderDate :string;
     dateofInspection :Date;
     inspectionBy :Boolean;
     inspectionByNames :string;
     modified :Date;
     created :Date;
     createdBy :string;
     modifiedBy :string;
}
